import React from 'react';
import { connect } from 'react-redux';
import { Route, Redirect, Switch } from 'react-router';
import { history } from '../_helpers';
import { alertActions } from '../_actions';
import { LoginPage, AutoLoginPage } from 'LoginPage';
import { RouteDefs } from '_constants';
import styles from './App.module.css';
import { faCheck, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AppAuth } from './AppAuth';
import { AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react';

class App extends React.Component {

    constructor(props) {
        super(props);

        const { dispatch } = this.props;
        history.listen((location, action) => {
            // clear alert on location change
            dispatch(alertActions.clear());
        });
    }


    renderAlert() {
        if (this.props.alert.message) {
            if (this.props.alert.type === 'alert-success') {
                return (
                    <div className={styles.alert_wrapper + ` ${this.props.alert.type}`}>
                        <div className={styles.alert_icon}>
                            <FontAwesomeIcon icon={faCheck} transform='up-4' />
                        </div>
                        <div className={styles.alert_message}>
                            {this.props.alert.message}
                        </div>
                    </div>
                );
            } else if (this.props.alert.type === 'alert-warning') {
                return (
                    <div className={styles.alert_wrapper + ` ${this.props.alert.type}`}>
                        <div className={styles.alert_icon}>
                            <FontAwesomeIcon icon={faExclamationTriangle} transform='up-4' color='orange' />
                        </div>
                        <div className={styles.alert_message}>
                            {this.props.alert.message}
                        </div>
                    </div>
                );
            } else {
                return (
                    <div className={styles.alert_error_wrapper + ` ${this.props.alert.type}`}>
                        <div className={styles.alert_icon}>
                            <FontAwesomeIcon icon={faExclamationTriangle} transform='up-4' color='red' />
                        </div>
                        <div className={styles.alert_message}>
                            {this.props.alert.message}
                        </div>
                    </div>
                );
            }
        }
    }



    render() {
        return (
            <div className={styles.content}>
                {this.renderAlert()}
                <Switch>
                    <Route exact path="/">
                        <AutoLoginPage key='autologinpage' />
                    </Route>
                    <Route path={RouteDefs.loginPage.path}>
                        <LoginPage />
                    </Route>
                    <Route path='/'>
                        <AuthenticatedTemplate>
                            <AppAuth />
                        </AuthenticatedTemplate>
                        <UnauthenticatedTemplate>
                            <Redirect to={RouteDefs.loginPage.path} />
                        </UnauthenticatedTemplate>
                    </Route>

                    <Redirect to={RouteDefs.loginPage.path} />
                </Switch>
            </div>
        )
    }
}

function mapStateToProps(state) {
    const { alert } = state.ui;
    return {
        alert
    };
}

const connectedApp = connect(mapStateToProps)(App);
export { connectedApp as App };
